module.exports = __webpack_public_path__ + "img/caret-round-right.6e2542f0.svg";